<div class="control">
  <label for="rich-text-input-{{ uniqueId }}"
    >{{ label
    }}<span class="has-text-danger-bis" *ngIf="required && showErrors">
      Provide a description of the tool is mandatory to the submission. The
      description is the main aspect of your tool. *</span
    >
    <span class="has-text-danger-bis" *ngIf="tooManyWords">
      Your text is too long ({{ maxWords }} words max)*</span
    >
  </label>
  <div
    class="input-wrapper"
    [ngClass]="{ 'is-danger-bis': (required && showErrors) || tooManyWords }"
  >
    <p class="help" *ngIf="helpText">{{ helpText }}</p>
    <ckeditor
      id="rich-text-input-{{ uniqueId }}"
      [editor]="editor"
      tagName="textarea"
      [data]="initialValue ? initialValue.value : null"
      [config]="editorConfig"
      (change)="onChange($event)"
      *ngIf="editor"
    ></ckeditor>
  </div>
</div>
